import { Injectable } from '@angular/core';
import { AppConfig } from '../app.config';
import { HelpersService } from './helpers.service';
import { Observable, throwError } from 'rxjs';
import { filter, map, catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { ErrorHandlerService } from './errorhandler.service';// Add this for error feedback

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  private apiURL: string = '';
  private apiURLNew: string = '';
  private apiKey: string = '';

  public username: string;
  public password: string;
  public returnUrl: string;
  public allowSkip: boolean = true;

  constructor(
    private http: HttpClient,
    private appConfig: AppConfig,
    private helpersService: HelpersService,
    private errorHandler: ErrorHandlerService,// Add this for error feedback
  ) {
    this.apiURL = this.appConfig.getEnvironment();
    this.apiURLNew = this.appConfig.getEnvironmentNew().url;
    this.apiKey = this.appConfig.getApiKey();
  }

  authenticate(username: string, password: string) {
    let body = `username=${username}&password=${encodeURIComponent(password)}&grant_type=${this.appConfig.getGrantType()}`;
    let requestOptions = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    };

    return this.http.post(this.apiURL + '/token', body, requestOptions).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((res: any) => {
        return throwError(res.json());
      }),
    );
  }

  authenticateClub(username: string, password: string) {
    let body = { username, password };

    console.log(body);

    let requestOptions = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    };

    return this.http
      .post(
        this.apiURLNew + `/Auth/Register?code=${this.apiKey}`,
        body,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  login(username: string, password: string, skipped: boolean = false) {
    let body = { username, password, skipped };
    let requestOptions = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    };

    return this.http
      .post(
        this.apiURLNew + '/Auth/ValidateLogin?code=' + this.apiKey,
        body,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  register2FA(username: string, password: string, code: string) {
    let body = { username, password, code };
    let requestOptions = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    };

    return this.http
      .post(
        this.apiURLNew + '/Auth/RegisterTwoFactorPin?code=' + this.apiKey,
        body,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  tokenLogin(username: string, password: string, code: string) {
    let body = { username, password, code };
    let requestOptions = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    };

    return this.http
      .post(
        this.apiURLNew + '/Auth/TokenLogin?code=' + this.apiKey,
        body,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  disableUser2FA() {
    var headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.apiURLNew + '/Auth/Disable2FA?code=' + this.apiKey,
        '',
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  enableUser2FA(code) {
    let body = { code };
    var headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.apiURLNew + '/Auth/Enable2FA?code=' + this.apiKey,
        body,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  resetPassword(email: string) {
    let body = { Email: email };
    let requestOptions = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    };

    return this.http
      .post(this.apiURL + '/Account/RequestPasswordReset', body)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  //Used by Super User
  resetUserPassword(userId: string, password: string) {
    let data = {
      UserID: userId,
      NewPassword: password,
    };
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();

    return this.http
      .post(this.apiURL + '/Account/ResetPassword', data, requestOptions)
      .pipe(
        map((res: any) => res),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  resetPasswordByUser(data: any) {
    var headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.apiURLNew + '/Athlete/ChangePassword?code=' + this.apiKey,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getInvalidDomains() {
    return this.http
      .get('https://hubtiger.blob.core.windows.net/baddomains/domains.json')
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  generate2FAQrCodeUri(email: string) {
    var headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.apiURLNew +
        `/Auth/GenerateQrCodeUri?username=${email}&code=` +
        this.apiKey,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  generate2FAQrCodeUri_Auth(email: string) {
    var headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.apiURLNew + `/Auth/GenerateQrCodeUri?code=` + this.apiKey,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  //   validateTwoFactorCode() {
  //     this.http.post('/api/twofactorauthenticator/validatetwofactorcode', { secretKey: this.secretKey, twoFactorCode: this.twoFactorCode }).subscribe((result: any) => {
  //       if (result) {
  //         alert('Valid code!');
  //       } else {
  //         alert('Invalid code!');
  //       }
  //     });
  // }

  xeroAuthRequest() {
    var headers = this.helpersService.getPOSApiHeaders(
      this.appConfig.getPOSEnvironment().key,
    );
    return this.http
      .get(
        this.appConfig.getPOSEnvironment().url + `/auth/xero`,
        headers
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          if (res.error) {
            return throwError(res.error);
          }

          return throwError(res);
        }),
      );
  }

  xeroExchangeToken(xerocode) {
    var headers = this.helpersService.getPOSApiHeaders(
      this.appConfig.getPOSEnvironment().key,
    );
    return this.http
      .get(
        this.appConfig.getPOSEnvironment().url + `/auth/xero/token?xerocode=${xerocode}`,
        headers
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          if (res.error) {
            return throwError(res.error);
          }

          return throwError(res);
        }),
      );
  }

  authenticateWithEntra(idToken: string, email: string): Observable<any> {
    // Send the Microsoft ID token to your backend
    // Your backend will validate it and return your standard auth tokens
    return this.http.post(`${this.apiURLNew}/Auth/EntraLogin?code=${this.apiKey}`, {
      idToken: idToken,
      email: email
    }).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((error) => {
        console.error('Entra authentication error:', error);
        return throwError(() => error);
      })
    );
  }

  authenticateWithEntraCode(code: string, codeVerifier: string, redirectUri: string): Observable<any> {
    // Send the authorization code to your backend
    // Your backend will exchange it for tokens with Azure AD
    return this.http.post(`${this.apiURLNew}/Auth/Login/Entra/Code?code=${this.apiKey}`, {
      code: code,
      redirectUri: redirectUri, 
      codeVerifier: codeVerifier
    }).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((error) => {
        console.error('Entra authentication error:', error);
        return throwError(() => error);
      })
    );
  }

  authenticateWithGigyaCode(code: string, codeVerifier: string, redirectUri: string): Observable<any> {
    // Send the authorization code to your backend
    // Your backend will exchange it for tokens with SAP Gigya
    return this.http.post(`${this.apiURLNew}/Auth/Login/Gigya/Code?code=${this.apiKey}`, {
      code: code,
      redirectUri: redirectUri,
      codeVerifier: codeVerifier
    }).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((error) => {
        console.error('Gigya authentication error:', error);
        return throwError(() => error);
      })
    );
  }

  refreshRolesFromGigya(){
    var headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(this.apiURLNew + `/Auth/RefreshRoles/Gigya?code=` + this.apiKey, headers)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );

  }
}